import React from 'react';
import IconTemplate from './IconTemplate';
import { openUrlInNewTab } from '../../../../helpers/attachments/openUrlInNewTab';
import { useAttachmentAction } from '../../services/attachmentAction';

const PdfIcon = ({ attachment }) => {
  const { loading, handler: onClick } = useAttachmentAction({
    attachment,
    action: openUrlInNewTab,
    mimeType: 'application/pdf',
  });

  return (
    <IconTemplate
      tooltipTitle="Просмотр"
      iconType={loading ? 'loading' : 'file-pdf'}
      onClick={onClick}
    />
  );
};

export default PdfIcon;
